import React, { useMemo } from 'react';
import { SvgCheckmarkCircle, SvgCloseCircle } from '@bexs/dollar-icons';
import Button from '@bexs/dollar/components/Button';
import { Transition } from 'react-transition-group';
import { UploadStatus } from 'store/ducks/upload/types';
import {
  FeedbackUploadBox,
  FeedbackInner,
  FadeInTop,
} from 'pages/Reports/sections/Upload/FeedbackUpload/styles';
import { CustomButton } from 'styles/global';

interface FeedbackProps {
  type: UploadStatus;
  isVisible: boolean;
  resetForm(): void;
}

const FeedbackUpload: React.FC<FeedbackProps> = ({
  isVisible,
  resetForm,
  type,
}) => {
  const renderSuccessFeedback = useMemo(() => {
    return (
      <FeedbackInner type="success">
        <SvgCheckmarkCircle color="#308E5F" size="5rem" />
        <h4>File successfully uploaded!</h4>
        <CustomButton
          type="button"
          variation="primary"
          size="large"
          onClick={resetForm}
        >
          Upload again
        </CustomButton>
      </FeedbackInner>
    );
  }, [resetForm]);

  const renderErrorFeedback = useMemo(() => {
    return (
      <FeedbackInner type="error">
        <SvgCloseCircle color="#EB5757" size="5rem" />
        <h4>There was an error</h4>
        <Button
          type="button"
          variation="danger"
          size="large"
          onClick={resetForm}
        >
          Try again
        </Button>
      </FeedbackInner>
    );
  }, [resetForm]);

  return (
    <Transition
      in={isVisible}
      mountOnEnter
      unmountOnExit
      addEndListener={() => true}
      timeout={{
        appear: 0,
        enter: 0,
        exit: 500,
      }}
    >
      {(state) => (
        <FadeInTop data-testid="fade-animation" state={state}>
          <FeedbackUploadBox data-testid="feedback-upload-box">
            {type === 'error' ? renderErrorFeedback : renderSuccessFeedback}
          </FeedbackUploadBox>
        </FadeInTop>
      )}
    </Transition>
  );
};

export default FeedbackUpload;
